import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

import {
  GlossRoutes,
  MainSettingsRoute,
} from "../../../../apps/ironfly-web/src/app/models/enum/routes.enum";

// Stripe sends a cancelled checkout back here (StripeConfigService.setPayload): a cold load of
// the app, which would otherwise be bounced to the initial route.
const BUNDLES_ROUTE = `${GlossRoutes.Settings}/${MainSettingsRoute.Plans}`;

function shouldRedirectToInitial(state: RouterStateSnapshot, initialRoute: string): boolean {
  // todo: @Sinan @Horace find out if we need jobID any more
  const allowedRoutes = [initialRoute, "redirect", "jobId", BUNDLES_ROUTE];
  return !allowedRoutes.some((route) => state.url.includes(route));
}

@Injectable({
  providedIn: "root",
})
export class InitialRedirectGuard {
  constructor(private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const initialRoute = "/" + GlossRoutes.Views;

    if (shouldRedirectToInitial(state, initialRoute)) {
      this.router.navigate([initialRoute]);
      return false;
    }
    return true;
  }
}
